require('./styled-select.less');
require('../m-scrollbar-default/m-scrollbar-default');

let styleSelects = function($select, overwriteOption = {}) {
    $select.each(function() {
        var $this = $(this);

        let options = {
            language: 'ru',
            minimumResultsForSearch: Infinity,
            dropdownParent: $this.parent()
        };

        if(!$.isEmptyObject(overwriteOption)){
            options = overwriteOption;
            options.dropdownParent = $this.parent();
        }

        $this
            .select2(options)
            .on('select2:open', function() {
                var $options = $this
                    .parent()
                    .find('.select2-container--default .select2-results > .select2-results__options');

                $options.mCustomScrollbar('destroy');
                $options.mCustomScrollbar('update');

                setTimeout(function() {
                    $options.mCustomScrollbar({
                        axis: 'y',
                        scrollbarPosition: 'inside',
                        advanced: {
                            updateOnContentResize: true
                        },
                        live: true
                    });
                }, 0);
            });
    });
};

module.exports.styleSelects = styleSelects;



// WEBPACK FOOTER //
// ./blocks/styled-select/styled-select.js